import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e, a;
var d;
var o, r;
null != (e = globalThis.dojoConfig) && e.has || null != (a = globalThis.esriConfig) && a.has ? d = _objectSpread(_objectSpread({}, null == (o = globalThis.dojoConfig) ? void 0 : o.has), null == (r = globalThis.esriConfig) ? void 0 : r.has) : d = {};

function i(e) {
  return "function" == typeof d[e] ? d[e] = d[e](globalThis) : d[e];
}

i.add = function (e, a, o, r) {
  return (r || void 0 === d[e]) && (d[e] = a), o && i(e);
}, i.cache = d, i.add("esri-deprecation-warnings", !0), function () {
  var e;
  i.add("host-webworker", void 0 !== globalThis.WorkerGlobalScope && self instanceof globalThis.WorkerGlobalScope);
  var a = "undefined" != typeof window && "undefined" != typeof location && "undefined" != typeof document && window.location === location && window.document === document;

  if (i.add("host-browser", a), i.add("host-node", "object" == typeof globalThis.process && (null == (e = globalThis.process.versions) ? void 0 : e.node) && globalThis.process.versions.v8), i.add("dom", a), i("host-browser")) {
    var _e = navigator,
        _a = _e.userAgent,
        _d = _e.appVersion,
        _o = parseFloat(_d);

    if (i.add("wp", parseFloat(_a.split("Windows Phone")[1]) || void 0), i.add("msapp", parseFloat(_a.split("MSAppHost/")[1]) || void 0), i.add("khtml", _d.includes("Konqueror") ? _o : void 0), i.add("edge", parseFloat(_a.split("Edge/")[1]) || void 0), i.add("opr", parseFloat(_a.split("OPR/")[1]) || void 0), i.add("webkit", !i("wp") && !i("edge") && parseFloat(_a.split("WebKit/")[1]) || void 0), i.add("chrome", !i("edge") && !i("opr") && parseFloat(_a.split("Chrome/")[1]) || void 0), i.add("android", !i("wp") && parseFloat(_a.split("Android ")[1]) || void 0), i.add("safari", !_d.includes("Safari") || i("wp") || i("chrome") || i("android") || i("edge") || i("opr") ? void 0 : parseFloat(_d.split("Version/")[1])), i.add("mac", _d.includes("Macintosh")), !i("wp") && _a.match(/(iPhone|iPod|iPad)/)) {
      var _e2 = RegExp.$1.replace(/P/, "p"),
          _d2 = _a.match(/OS ([\d_]+)/) ? RegExp.$1 : "1",
          _o2 = parseFloat(_d2.replace(/_/, ".").replace(/_/g, ""));

      i.add(_e2, _o2), i.add("ios", _o2);
    }

    i.add("trident", parseFloat(_d.split("Trident/")[1]) || void 0), i("webkit") || (!_a.includes("Gecko") || i("wp") || i("khtml") || i("trident") || i("edge") || i.add("mozilla", _o), i("mozilla") && i.add("ff", parseFloat(_a.split("Firefox/")[1] || _a.split("Minefield/")[1]) || void 0));
  }
}(), function () {
  if (globalThis.navigator) {
    var _e3 = navigator.userAgent,
        _a2 = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile/i.test(_e3),
        _d3 = /iPhone/i.test(_e3);

    _a2 && i.add("esri-mobile", _a2), _d3 && i.add("esri-iPhone", _d3), i.add("esri-geolocation", !!navigator.geolocation);
  }

  i.add("esri-canvas-svg-support", !i("trident")), i.add("esri-wasm", "WebAssembly" in globalThis), i.add("esri-shared-array-buffer", function () {
    var e = ("SharedArrayBuffer" in globalThis),
        a = !1 === globalThis.crossOriginIsolated;
    return e && !a;
  }), i.add("esri-atomics", "Atomics" in globalThis), i.add("esri-workers", "Worker" in globalThis), i.add("esri-text-decoder", "TextDecoder" in globalThis), i.add("esri-text-encoder", "TextEncoder" in globalThis), i.add("web-feat:cache", "caches" in globalThis), i.add("esri-workers-arraybuffer-transfer", !i("safari") || Number(i("safari")) >= 12), i.add("featurelayer-simplify-thresholds", [.5, .5, .5, .5]), i.add("featurelayer-simplify-payload-size-factors", [1, 1, 4]), i.add("featurelayer-snapshot-enabled", !0), i.add("featurelayer-snapshot-point-min-threshold", 8e4), i.add("featurelayer-snapshot-point-max-threshold", 4e5), i.add("featurelayer-snapshot-point-coverage", .1), i.add("featurelayer-advanced-symbols", !1), i.add("featurelayer-pbf", !0), i.add("featurelayer-pbf-statistics", !1), i.add("feature-layers-workers", !0), i.add("mapview-transitions-duration", 200), i.add("mapserver-pbf-enabled", !1), i.add("vectortilelayer-max-buffers", i("ff") ? 160 : Number.POSITIVE_INFINITY), i("host-webworker") || i("host-browser") && (i.add("esri-csp-restrictions", function () {
    try {
      new Function();
    } catch (_unused) {
      return !0;
    }

    return !1;
  }), i.add("esri-image-decode", function () {
    if ("decode" in new Image()) {
      var _e4 = new Image();

      return _e4.src = 'data:image/svg+xml;charset=UTF-8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg"></svg>', void _e4.decode().then(function () {
        i.add("esri-image-decode", !0, !0, !0);
      }).catch(function () {
        i.add("esri-image-decode", !1, !0, !0);
      });
    }

    return !1;
  }), i.add("esri-url-encodes-apostrophe", function () {
    var e = window.document.createElement("a");
    return e.href = "?'", e.href.includes("?%27");
  }));
}();
export { i as default };